import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faLinkedin as fabLinkedIn, faSquareFacebook as fabSquareFacebook } from '@fortawesome/free-brands-svg-icons';
import { faLocationDot as farLocationDot, faPhone as farPhone } from '@fortawesome/pro-regular-svg-icons';
import {
	faArrowLeft as fasArrowLeft,
	faArrowRight as fasArrowRight,
	faBars as fasBars,
	faCaretRight as fasCaretRight,
	faChartColumn as fasChartColumn,
	faChartKanban as fasChartKanban,
	faCheck as fasCheck,
	faChevronLeft as fasChevronLeft,
	faChevronRight as fasChevronRight,
	faCircle as fasCircle,
	faCircleCheck as fasCircleCheck,
	faCircleDollar as fasCircleDollar,
	faCircleQuestion as fasCircleQuestion,
	faDollarSign as fasDollarSign,
	faEnvelopeCircleCheck as fasEnvelopeCircleCheck,
	faFileCertificate as fasFileCertificate,
	faFileSignature as fasFileSignature,
	faGears as fasGears,
	faGift as fasGift,
	faGlobePointer as fasGlobePointer,
	faMicrochipAi as fasMicrochipAi,
	faPartyHorn as fasPartyHorn,
	faSeedling as fasSeedling,
	faSpinner as fasSpinner,
	faSquare as fasSquare,
	faTimer as fasTimer,
	faXmark as fasXmark,
} from '@fortawesome/pro-solid-svg-icons';
import { MaskitoDirective } from '@maskito/angular';
import { NgbCarouselModule, NgbDropdownModule, NgbModalModule, NgbNavModule, NgbOffcanvasModule } from '@ng-bootstrap/ng-bootstrap';

import { CostEstimatorChartComponent } from './components/cost-estimator/cost-estimator-chart/cost-estimator-chart.component';
import { CostEstimatorComponent } from './components/cost-estimator/cost-estimator.component';
import { FormDropdownComponent } from './components/form-dropdown/form-dropdown.component';
import { SuccessMetricsComponent } from './components/success-metrics/success-metrics.component';
import { SupplierCarouselComponent } from './components/supplier-carousel/supplier-carousel.component';
import { TestimonialCarouselComponent } from './components/testimonial-carousel/testimonial-carousel.component';
import { CalendlyWidgetDirective } from './directives/calendly-widget/calendly-widget.directive';
import { ContactUsWidgetDirective } from './directives/contact-us-widget/contact-us-widget.directive';
import { LoaderComponent } from './loader/loader.component';
import { NewsletterModalComponent } from './modals/newsletter-modal/newsletter-modal.component';
import { PhonePipe } from './pipes/phone.pipe';
import { ShortNumberPipe } from './pipes/short-number.pipe';

@NgModule({
	declarations: [
		CalendlyWidgetDirective,
		LoaderComponent,
		PhonePipe,
		ShortNumberPipe,
		SuccessMetricsComponent,
		SupplierCarouselComponent,
		TestimonialCarouselComponent,
		CostEstimatorComponent,
		CostEstimatorChartComponent,
		FormDropdownComponent,
		NewsletterModalComponent,
		ContactUsWidgetDirective,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		FontAwesomeModule,
		NgbDropdownModule,
		NgbOffcanvasModule,
		NgbModalModule,
		NgbCarouselModule,
		NgbNavModule,
		MaskitoDirective,
	],
	providers: [provideHttpClient(withInterceptorsFromDi()), PhonePipe, ShortNumberPipe],
	exports: [
		FontAwesomeModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		NgbDropdownModule,
		NgbOffcanvasModule,
		NgbModalModule,
		CalendlyWidgetDirective,
		LoaderComponent,
		NgbCarouselModule,
		NgbNavModule,
		PhonePipe,
		ShortNumberPipe,
		MaskitoDirective,
		SuccessMetricsComponent,
		SupplierCarouselComponent,
		TestimonialCarouselComponent,
		CostEstimatorComponent,
		CostEstimatorChartComponent,
		FormDropdownComponent,
		NewsletterModalComponent,
		ContactUsWidgetDirective,
	],
})
export class SharedModule {
	constructor(library: FaIconLibrary) {
		library.addIcons(
			fabSquareFacebook,
			fabLinkedIn,
			fasBars,
			fasCaretRight,
			fasCircleCheck,
			fasChartColumn,
			fasCheck,
			fasPartyHorn,
			fasGift,
			fasCircle,
			fasChartKanban,
			fasFileCertificate,
			fasGears,
			fasGlobePointer,
			fasTimer,
			fasEnvelopeCircleCheck,
			fasMicrochipAi,
			fasFileSignature,
			fasChevronLeft,
			fasChevronRight,
			fasCircleQuestion,
			fasCircleDollar,
			fasSeedling,
			fasSpinner,
			fasXmark,
			fasSquare,
			fasDollarSign,
			fasArrowRight,
			fasArrowLeft,
			farPhone,
			farLocationDot,
		);
	}
}
